module.exports = __webpack_public_path__ + "img/beanie.94aba574.png";